import { TOOL_COUNT } from '../data/tools';

function ArrowIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M5 12h14M13 6l6 6-6 6" />
        </svg>
    );
}

function PlaneIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M21 16v-2l-8-5V3.5a1.5 1.5 0 0 0-3 0V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z" />
        </svg>
    );
}

export function Hero() {
    return (
        <section className="tkh-hero" aria-labelledby="hero-title">
            <div className="tkh-wrap">
                <div className="tkh-load">
                    <p className="tkh-eyebrow" style={{ '--i': 0 } as React.CSSProperties}>
                        Model Context Protocol · Turkish Airlines
                    </p>
                    <h1 id="hero-title" style={{ '--i': 1 } as React.CSSProperties}>
                        Turkish Airlines, <em>on call</em> inside your AI assistant.
                    </h1>
                    <p className="tkh-lede" style={{ '--i': 2 } as React.CSSProperties}>
                        One MCP server, {TOOL_COUNT} tools. Live flight status, real fares, your booking, baggage, upgrades and the Istanbul stopover — answered in the chat you already use, with rich cards instead of copied links.
                    </p>
                    <div className="tkh-cta" style={{ '--i': 3 } as React.CSSProperties}>
                        <a href="#connect" className="tkh-btn tkh-btn-primary">
                            Connect in a minute <ArrowIcon />
                        </a>
                        <a href="#tools" className="tkh-btn tkh-btn-ghost">
                            See the departures board
                        </a>
                    </div>
                    <div className="tkh-works" style={{ '--i': 4 } as React.CSSProperties}>
                        Works with
                        <span>ChatGPT</span>
                        <span>Claude</span>
                        <span>Cursor</span>
                        <span>VS Code</span>
                        <span>any MCP client</span>
                    </div>
                </div>

                <div className="tkh-pass-wrap" aria-hidden="true">
                    <div className="tkh-pass-enter" style={{ '--i': 3 } as React.CSSProperties}>
                        <div className="tkh-pass">
                            <div className="tkh-pass-head">
                                <img src="/assets/logo.svg" alt="" />
                                <span>Boarding pass · Tool call</span>
                            </div>
                            <div className="tkh-pass-body">
                                <div className="tkh-pass-route">
                                    <div>
                                        <div className="code">YOU</div>
                                        <div className="city">Your assistant</div>
                                    </div>
                                    <div className="tkh-pass-plane">
                                        <span className="dots" />
                                        <PlaneIcon />
                                        <span className="dots" />
                                    </div>
                                    <div className="to">
                                        <div className="code">TK</div>
                                        <div className="city">Turkish Airlines</div>
                                    </div>
                                </div>
                                <dl className="tkh-pass-grid">
                                    <div>
                                        <dt>Tool</dt>
                                        <dd>flight-status</dd>
                                    </div>
                                    <div>
                                        <dt>Flight</dt>
                                        <dd>TK 1</dd>
                                    </div>
                                    <div>
                                        <dt>Route</dt>
                                        <dd>IST → JFK</dd>
                                    </div>
                                    <div>
                                        <dt>Status</dt>
                                        <dd className="ok">On time</dd>
                                    </div>
                                </dl>
                            </div>
                            <div className="tkh-pass-stub">
                                <pre>{'{ "flightNumber": "TK1",\n  "flightDate": "today" }'}</pre>
                                <div className="tkh-barcode" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
